import {
  SCA_RESUME_REQUEST,
  SCA_RESUME_SUCCESS,
  SCA_RESUME_FAILURE,
  SCA_RESUME_TICK_COOLDOWN,
} from '../constants';

const initial = {
  scaResumeLoading: false,
  scaResumeError: null, // 'resume_failed' | 'start_over' | 'server_error' | 'unknown'
  scaResumeCooldown: 0, // seconds left until user can retry
};

export default function scaResume(state = initial, action = {}) {
  switch (action.type) {
    case SCA_RESUME_REQUEST:
      return { ...state, scaResumeLoading: true, scaResumeError: null };

    case SCA_RESUME_SUCCESS:
      return { ...state, scaResumeLoading: false, scaResumeError: null };

    case SCA_RESUME_FAILURE: {
      const err = action.error || 'unknown';
      let cd = Number(state.scaResumeCooldown || 0);
      if (err === 'resume_failed' && cd < 5) cd = 5;
      if (err === 'server_error' && cd < 5) cd = 5;
      return {
        ...state,
        scaResumeLoading: false,
        scaResumeError: err,
        scaResumeCooldown: cd,
      };
    }

    case SCA_RESUME_TICK_COOLDOWN:
      return { ...state, scaResumeCooldown: Math.max(0, (state.scaResumeCooldown || 0) - 1) };

    default:
      return state;
  }
}
